export default "__VITE_ASSET__f67749ed__"